import React from "react";
import './Accommodation.css';

import { FaChartArea, FaUsers } from "react-icons/fa";

import { Link } from "react-router-dom";


const Accommodation = ({ acco }) => {

    return (

        <div className="acco-item">

            <img src={acco.image} alt={acco.title} /> {/* Accommodation Image */}

            <div className="content">

                <div className="price">{acco.details.reservationCost}</div>

                    {/* Link to the individual Accommodation page */}
                    <Link
                        to={{
                            pathname: '/Accommodations/' + acco.title,  // Navigate to the specific Accommodation page
                        }}
                        location = {{acco}}  // Passing Accommodation details to the linked page
                        state= {acco}> 
                        <span></span>
                        <h2>{acco.title}</h2> {/* Accommodation Title */}
                         
                    </Link>

                    <p>{acco.content}</p>

                    {/* Accommodation details section */}
                    <div className='details'>

                        {/* People Capacity */}
                        <h3>
                            <div className='icon'><FaUsers /></div>
                            <span>{acco.details.peopleCapacity}</span>
                        </h3>

                        {/* Accommodation Area Size */}
                        <h3>
                            <div className='icon'><FaChartArea /></div>
                            <span>{acco.details.size}</span>
                        </h3>

                    </div>

            </div>

        </div>
    );
};

export default Accommodation;